<div class="filtros-tab-container">
  @if (carregando) {
    @for (item of skeletonArray; track $index) {
      <div class="skeleton filtros-tab-skeleton-item"></div>
    }
  } @else {
    @for (aba of abas; track aba.valor) {
      <button
        type="button"
        class="filtros-tab-item"
        [class.filtros-tab-item-ativa]="aba.valor === abaAtiva"
        (click)="selecionar(aba.valor)"
      >
        @if (aba.corBolinha) {
          <span class="filtros-tab-bolinha" [style.backgroundColor]="aba.corBolinha"></span>
        }
        <span class="filtros-tab-label">{{ aba.label }}</span>
        @if (aba.contador !== undefined) {
          <span class="filtros-tab-contador">{{ aba.contador }}</span>
        }
      </button>
    }
  }
</div>
